import styled, { css } from 'styled-components';

export const PageHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px 24px;
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 20px;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  flex: 1 1 240px;
`;

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding-top: 2px;
`;

export const FilterLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

type SwitchPartsProps = { $active: boolean };

export const SwitchButton = styled.button.attrs({ type: 'button' })`
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: inherit;
  font: inherit;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(11, 41, 251, 0.45);
    border-radius: 14px;
  }
`;

export const SwitchTrack = styled.span<SwitchPartsProps>`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: #bdbdbd;
  transition: background 0.2s ease;

  ${({ $active }) =>
    $active &&
    css`
      background: #0b29fb;
    `}
`;

export const SwitchKnob = styled.span<SwitchPartsProps>`
  position: absolute;
  left: 3px;
  top: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;

  ${({ $active }) =>
    $active &&
    css`
      transform: translateX(20px);
    `}
`;

export const Title = styled.h1`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 1.35;
  color: #0b29fb;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;
